// libs
import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';

// components
import Discount from 'shared/components/Header/Discount';

// analytics
import DTM from 'shared/helpers/DTM';

// styles
import { PromoBannerContainer, DownArrow, Banner, BannerSection, Icon } from './styles';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// urls
import { APP_PROMO, HELP_CENTER } from 'shared/constants/uri';

// defs
export interface IPromotionalBannerStateProps {
  selectedCurrency: string;
  selectedCountry: string;
  currencyDisplayValue: string;
  isI18NEnabled?: boolean;
}

export interface IPromotionalBannerDispatchProps {
  openCountryCurrencySettings: VoidFunction;
}

export interface IPromotionalBannerProps
  extends IPromotionalBannerStateProps,
    IPromotionalBannerDispatchProps {}

const LABELS = {
  APP_DOWNLOAD: 'App Download',
  HELP: 'Help',
};

const PromotionalBanner = ({
  openCountryCurrencySettings,
  selectedCurrency,
  currencyDisplayValue,
  selectedCountry,
  isI18NEnabled,
}: IPromotionalBannerProps) => {
  useEffect(() => {
    DTM.currency = selectedCurrency;
  }, [selectedCurrency]);

  currencyDisplayValue = currencyDisplayValue !== selectedCurrency ? currencyDisplayValue : '';
  const showDropArrow = isI18NEnabled && (currencyDisplayValue || selectedCurrency);

  const handleClick = () => {
    isI18NEnabled && openCountryCurrencySettings();
  };

  const goToHelp = () => {
    window.open(HELP_CENTER);
  };

  const goToAppDownload = () => {
    window.open(APP_PROMO);
  };

  return (
    <PromoBannerContainer>
      <Banner>
        <BannerSection>
          <div className="sub-icons">
            {isI18NEnabled && (
              <Icon onClick={handleClick}>
                <i className="icon-location" />
                {selectedCountry}
                {showDropArrow && <DownArrow />}
              </Icon>
            )}

            {isI18NEnabled && (
              <Icon onClick={handleClick}>
                <i className="icon-card" />
                {selectedCurrency}
                {showDropArrow && <DownArrow />}
              </Icon>
            )}
          </div>
          <Discount />
          <div className="sub-icons">
            <Icon onClick={goToAppDownload} className="icon app-download">
              <i className="icon-mobile" />
              {LABELS.APP_DOWNLOAD}
            </Icon>

            <Icon onClick={goToHelp} className="icon">
              <i className="icon-help" />
              {LABELS.HELP}
            </Icon>
          </div>
        </BannerSection>
      </Banner>
    </PromoBannerContainer>
  );
};

const mapStateToProps = (state: any) => {
  let isI18NEnabled;

  try {
    isI18NEnabled = getRemoteConfig(state, 'isI18nEnabled');
  } catch (e) {
    isI18NEnabled = false;
  }

  return {
    isI18NEnabled,
  };
};

export default connect(mapStateToProps)(memo(PromotionalBanner));
